import script from "./BookTableWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./BookTableWidget.vue?vue&type=script&setup=true&lang=js"

import "./BookTableWidget.vue?vue&type=style&index=0&id=707eef66&lang=scss"

const __exports__ = script;

export default __exports__